import {Component, Input, OnChanges} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {marked} from 'marked';

@Component({
  selector: 'app-markdown',
  imports: [],
  templateUrl: './markdown.component.html',
  styleUrl: './markdown.component.scss'
})
export class MarkdownComponent implements OnChanges {
  @Input() rawMarkdown = '';
  // parseInline (the default, used by copilot messages) renders no block elements — headings, lists
  // and paragraphs come out as plain text. Document-style content (e.g. brand research memory)
  // needs block mode.
  @Input() block = false;
  // SECURITY: marked passes raw HTML through verbatim, so by default the parsed output is handed to
  // [innerHTML] as a plain string and Angular's sanitizer strips scripts/event handlers (headings,
  // lists, tables, emphasis all survive). trusted=true bypasses the sanitizer and exists ONLY to
  // preserve the pre-existing copilot behavior — never set it for content a third party can
  // influence (the research memory is written by a web-browsing LLM: a brand's own webpage could
  // prompt-inject markup into it).
  @Input() trusted = false;
  htmlContent: SafeHtml | string = '';

  constructor(private sanitizer: DomSanitizer) {
    marked.setOptions({breaks: true, gfm: true});
  }

  async ngOnChanges() {
    const escaped = this.rawMarkdown.replace(/~/g, '\\~');
    const rawHtml = this.block ? await marked.parse(escaped) : await marked.parseInline(escaped);
    this.htmlContent = this.trusted ? this.sanitizer.bypassSecurityTrustHtml(rawHtml) : rawHtml;
  }
}
